<div class="row flex grow bill-account-tile items-center">
  <div class="column margin-right-20 margin-top-5">
    <span class="policy-icon" [ngClass]="billAccountTile?.policyTypeIcon" role="img"></span>
  </div>
  <div class="column grow">
    <div class="row">{{ billAccountTile?.riskDescriptions }}</div>
    <div class="row bill-account-name">{{ billAccountTile?.accountName }}</div>
  </div>
</div>
